module.exports = __webpack_public_path__ + "img/ring_y_skip_0_1.c3ef2320.png";